import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
// Assets
import ClientLogo01 from "../../assets/img/clients/logo01.svg"
import ClientLogo02 from "../../assets/img/clients/logo02.svg";
import ClientLogo03 from "../../assets/img/clients/logo03.svg";
import ClientLogo04 from "../../assets/img/clients/logo04.svg";
import ClientLogo05 from "../../assets/img/clients/logo05.svg";
import ClientLogo06 from "../../assets/img/clients/logo06.svg";
import ClientLogo07 from "../../assets/img/clients/logo07.svg"
import ClientLogo08 from "../../assets/img/clients/logo08.svg"
import ClientLogo09 from "../../assets/img/clients/logo09.svg";
import ClientLogo10 from "../../assets/img/clients/logo10.svg";
import ClientLogo11 from "../../assets/img/clients/logo11.svg";
import ClientLogo12 from "../../assets/img/clients/logo12.svg";
import ClientLogo13 from "../../assets/img/clients/logo13.svg";
import ClientLogo14 from "../../assets/img/clients/logo14.svg"
import ClientLogo15 from "../../assets/img/clients/logo15.svg";
import ClientLogo16 from "../../assets/img/clients/logo16.svg";
import ClientLogo17 from "../../assets/img/clients/logo17.svg";
import ClientLogo18 from "../../assets/img/clients/logo18.svg";
import ClientLogo19 from "../../assets/img/clients/logo19.svg";
import ClientLogo20 from "../../assets/img/clients/logo20.svg";
import ClientLogo21 from "../../assets/img/clients/logo21.svg";
import ClientLogo22 from "../../assets/img/clients/logo22.svg";
import ClientLogo23 from "../../assets/img/clients/logo23.svg";
import ClientLogo24 from "../../assets/img/clients/logo24.svg";
import ClientLogo25 from "../../assets/img/clients/logo25.svg";
import ClientLogo26 from "../../assets/img/clients/logo26.svg";
export default function ClientSlider() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow:10,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <Slider {...settings}>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo01} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo02} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo03} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo04} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo05} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo06} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo07} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo08} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo09} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo10} alt="client logo" />
        </LogoWrapper> 
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo11} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo12} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo13} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo14} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo15} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo16} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo17} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo18} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo19} alt="client logo" />
        </LogoWrapper>
        <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo20} alt="client logo" />
        </LogoWrapper>
           <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo21} alt="client logo" />
        </LogoWrapper>
           <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo22} alt="client logo" />
        </LogoWrapper> 
           <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo23} alt="client logo" />
        </LogoWrapper>
           <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo24} alt="client logo" />
        </LogoWrapper>
          <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo25} alt="client logo" />
        </LogoWrapper>
          <LogoWrapper className="flexCenter">
          <ImgStyle src={ClientLogo26} alt="client logo" />
        </LogoWrapper>
        
      </Slider>
    </div>
  );
}

const LogoWrapper = styled.div`
  width: 100%;
  height: 100px;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;
const ImgStyle = styled.img`
  width: 100%;
  height: 100%;
  padding: 10%;
`;